import { applicationActions } from "../reducer";

import { ActiveModal } from '../../types';

export const deleteActiveModal = (value: ActiveModal) => applicationActions.deleteActiveModal(value);
